export const DIVISOR_PREFERENCE_MIN_RATIO = 0.9;
export const WHOLE_FACTOR_MIN_FITTING_EDGE = 1024;
function edgeLimitedEdge(sourceEdge, maxEdge) {
    if (!(maxEdge > 0) || sourceEdge <= maxEdge) {
        return sourceEdge;
    }
    const fitting = Math.max(1, Math.floor(maxEdge));
    return fitting > WHOLE_FACTOR_MIN_FITTING_EDGE
        ? Math.ceil(sourceEdge / Math.ceil(sourceEdge / fitting))
        : fitting;
}
function largestAxis(dimensions) {
    let axis = 0;
    for (let other = 1; other < 3; other++) {
        if (dimensions[other] > dimensions[axis]) {
            axis = other;
        }
    }
    return axis;
}
function preferDivisor(sourceEdge, fitting) {
    for (let factor = Math.ceil(sourceEdge / fitting); sourceEdge / factor >= DIVISOR_PREFERENCE_MIN_RATIO * fitting; factor++) {
        if (sourceEdge % factor === 0) {
            return sourceEdge / factor;
        }
    }
    return fitting;
}
function boxAverageReductionFactors(dimensions, limits) {
    const { maxEdge, maxVoxelCount } = limits ?? {};
    const reduced = dimensions.map((edge) => Math.max(1, edgeLimitedEdge(edge, maxEdge)));
    if (maxVoxelCount > 0) {
        while (reduced[0] * reduced[1] * reduced[2] > maxVoxelCount) {
            const axis = largestAxis(reduced);
            if (reduced[axis] <= 1) {
                break;
            }
            reduced[axis] -= 1;
        }
    }
    return reduced.map((edge, axis) => edge >= dimensions[axis]
        ? 1
        : dimensions[axis] / preferDivisor(dimensions[axis], edge));
}
export { boxAverageReductionFactors as default, boxAverageReductionFactors, largestAxis, };
